module.exports = __webpack_public_path__ + "media/ring-billed-gull-3.e9a95eb8.mp3";